import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue";
const _hoisted_1 = { class: "maintenance-schedule__description" };
const _hoisted_2 = { class: "description__title" };
const _hoisted_3 = { class: "description__narrative" };
const _hoisted_4 = { class: "description__severe-title" };
const _hoisted_5 = { class: "description__severe-items" };
const _hoisted_6 = { class: "description__severe-items--list-one" };
const _hoisted_7 = { class: "description__severe-items--list-two" };
const _hoisted_8 = { class: "maintenance-schedule__selected-vehicle" };
const _hoisted_9 = { class: "selected-vehicle__photo" };
const _hoisted_10 = ["src", "alt"];
const _hoisted_11 = { class: "selected-vehicle__details" };
const _hoisted_12 = { class: "details__year-model" };
const _hoisted_13 = { class: "details__trim" };
const _hoisted_14 = { class: "details__mileage" };
const _hoisted_15 = { class: "maintenance-schedule__schedule" };
const _hoisted_16 = { class: "schedule-type-container" };
const _hoisted_17 = {
    id: "maintenanceScheduleTypeTitle",
    class: "schedule-type__title"
};
const _hoisted_18 = {
    class: "schedule-results-container",
    "aria-labelledby": "maintenanceScheduleTypeTitle"
};
const _hoisted_19 = { class: "schedule-results__service-schedule-list" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("div", {
    id: "scheduleListTitle",
    class: "service-schedule-list__title"
}, " Service Schedules ", -1 /* HOISTED */);
const _hoisted_21 = {
    class: "service-schedule-list__service-schedule-names",
    "aria-labelledby": "scheduleListTitle",
    "aria-controls": "serviceDetails",
    role: "tablist",
    tabindex: "0"
};
const _hoisted_22 = ["data-mileage", "onKeydown", "onClick"];
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-caret-right" }, null, -1 /* HOISTED */);
const _hoisted_24 = { class: "service-schedule-name__name" };
const _hoisted_25 = { class: "schedule-results__service-details-list" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("div", {
    id: "scheduleDetailsTitle",
    class: "service-details-list__title"
}, " Service Details ", -1 /* HOISTED */);
const _hoisted_27 = {
    id: "serviceDetails",
    class: "service-details-list__details",
    "aria-labelledby": "scheduleDetailsTitle",
    tabindex: "0"
};
const _hoisted_28 = { class: "detail__action" };
const _hoisted_29 = { class: "detail__item" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.description.title), 1 /* TEXT */),
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.description.narrative), 1 /* TEXT */),
            _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.description.severeTitle), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_5, [
                _createElementVNode("ul", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.description.severeItemsListOne, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                            key: index,
                            class: "severe-item"
                        }, _toDisplayString(item), 1 /* TEXT */));
                    }), 128 /* KEYED_FRAGMENT */))
                ]),
                _createElementVNode("ul", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.description.severeItemsListTwo, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                            key: index,
                            class: "severe-item"
                        }, _toDisplayString(item), 1 /* TEXT */));
                    }), 128 /* KEYED_FRAGMENT */))
                ])
            ]),
            _createElementVNode("button", {
                class: "description__new-vehicle",
                onClick: _cache[0] || (_cache[0] =
                    //@ts-ignore
                    (...args) => (_ctx.chooseNewVehicle && _ctx.chooseNewVehicle(...args)))
            }, " Choose A New Vehicle ")
        ]),
        _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("img", {
                    src: _ctx.selectedVehicleDetails.photoUrl,
                    alt: _ctx.selectedVehicleDetails.model
                }, null, 8 /* PROPS */, _hoisted_10)
            ]),
            _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.selectedVehicleDetails.year) + " " + _toDisplayString(_ctx.selectedVehicleDetails.model), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.selectedVehicleDetails.trim), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.selectedVehicleDetails.mileage) + " miles ", 1 /* TEXT */)
            ])
        ]),
        _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                    class: _normalizeClass(["schedule-type__btn schedule-type--normal",
                        _ctx.selectedMaintenanceScheduleType == 'severe'
                            ? 'schedule-type__btn--active'
                            : ''
                    ]),
                    "arial-label": "Get Normal Maintenance Schedule",
                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.getMaintenanceSchedule()))
                }, " Normal ", 2 /* CLASS */),
                _createElementVNode("button", {
                    class: _normalizeClass(["schedule-type__btn schedule-type--severe",
                        _ctx.selectedMaintenanceScheduleType == 'normal'
                            ? 'schedule-type__btn--active'
                            : ''
                    ]),
                    "arial-label": "Get Severe Maintenance Schedule",
                    onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.getMaintenanceSchedule()))
                }, " Severe ", 2 /* CLASS */),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.resultsTitle), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("ul", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultsServiceScheduleNames, (schedule, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: index,
                                class: "service-schedule-name",
                                "data-mileage": schedule.mileage,
                                role: "tab",
                                tabindex: "0",
                                onKeydown: [
                                    _withKeys(($event) => (_ctx.getSelectedSchedule($event, index)), ["enter"]),
                                    _cache[3] || (_cache[3] = _withKeys(
                                    //@ts-ignore
                                    (...args) => (_ctx.focusDetails && _ctx.focusDetails(...args)), ["right"]))
                                ],
                                onClick: ($event) => (_ctx.getSelectedSchedule($event, index))
                            }, [
                                _hoisted_23,
                                _createElementVNode("div", _hoisted_24, _toDisplayString(schedule.name), 1 /* TEXT */)
                            ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_22));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("ul", _hoisted_27, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultsServiceDetails, (detail, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: index,
                                class: "detail",
                                tabindex: "0"
                            }, [
                                _createElementVNode("span", _hoisted_28, _toDisplayString(detail.action) + ": ", 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_29, _toDisplayString(detail.item), 1 /* TEXT */)
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ])
            ])
        ])
    ]));
}
